module.exports = __webpack_public_path__ + "media/components/assets/icons/checkbox_not_click-8dee9700f7bd5ccce4afdf02d1b6aebe.svg";